import { BLACK, PRIMARY_COLOR } from '../../theme/colorConstants';
import { PRIMARY_FONT } from '../../theme/fontConstants';

export const TEXT_MUTED = '#747487';
export const TEXT_BLACK = '#000000';

export const redesignTitleSx = {
  '&&': {
    fontSize: '18px',
    fontFamily: PRIMARY_FONT[700],
    lineHeight: 'normal',
    color: TEXT_BLACK,
  },
};

export const redesignCorpSx = {
  '&&': {
    fontSize: '14px',
    fontFamily: PRIMARY_FONT[400],
    lineHeight: '16px',
    color: TEXT_MUTED,
  },
};

export const redesignEmployeesStyle = {
  fontFamily: PRIMARY_FONT[500],
  fontSize: '10px',
  lineHeight: '16px',
  color: TEXT_MUTED,
};

export const redesignNameSx = {
  fontFamily: PRIMARY_FONT[500],
  fontSize: '13px',
  lineHeight: '19px',
  color: BLACK[80],
  textDecoration: 'underline',
};

export const redesignTotalLabelSx = {
  fontFamily: PRIMARY_FONT[400],
  fontSize: '14px',
  lineHeight: 'normal',
  color: BLACK[70],
};

export const redesignTotalValueSx = {
  fontFamily: PRIMARY_FONT[900],
  fontSize: '18px',
  lineHeight: 'normal',
  color: PRIMARY_COLOR[70],
};

export const redesignTimeHeaderSx = {
  flex: 1,
  textAlign: 'center',
  fontFamily: PRIMARY_FONT[500],
  fontSize: '10.5px',
  lineHeight: '18px',
  color: BLACK[80],
  textTransform: 'none',
};

export const redesignClockSx = {
  flex: 1,
  textAlign: 'center',
  fontFamily: PRIMARY_FONT[400],
  fontSize: '12px',
  lineHeight: '24px',
  color: TEXT_BLACK,
};

export const redesignHoursSx = {
  ...redesignClockSx,
  fontFamily: PRIMARY_FONT[700],
};

export const redesignRowTotalSx = {
  textAlign: 'center',
  fontFamily: PRIMARY_FONT[900],
  fontSize: '13px',
  lineHeight: '24px',
  color: PRIMARY_COLOR[70],
};

export const redesignActionButtonsSx = {
  '&& .MuiButton-root': {
    fontFamily: PRIMARY_FONT[700],
    fontSize: '10px',
    height: '20px',
    minHeight: '20px',
    lineHeight: 'normal',
  },
};
